import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getMessaging } from "firebase/messaging";

const firebaseConfig = {
  apiKey: "AIzaSyCDayXL_PFAkZZZ2OddzhUbMxKlImDXodg",
  authDomain: "giepei.firebaseapp.com",
  projectId: "giepei",
  storageBucket: "giepei.firebasestorage.app",
  messagingSenderId: "302990454170",
  appId: "1:302990454170:web:59052b5b53659e7f375e23",
  measurementId: "G-FTWL4JB3NV"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
export const messaging = getMessaging(app);
export default app;
